import { render, staticRenderFns } from "./AffiliateLink.vue?vue&type=template&id=31052c68&"
import script from "./AffiliateLink.vue?vue&type=script&lang=js&"
export * from "./AffiliateLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports